<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                    <h2 class="mb-4">Complete FollowUp</h2>
                    <!-- <div style="float: right;">
                        <button type="button" class="btn btn-primary" (click)="addStaff()">Add Subfranchise</button>
                    </div> -->
               

                <!-- Data Table -->
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                       
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Mobile</th>
                                <th>Followup Date</th>
                                <th>Description</th>
                                <th>Service Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let records of allStaffRecords; let i =index;">
                                <tr style="cursor: pointer;" >
                                    <td (click)="toggleRow(i)">{{ i+1}}</td>
                                    <td (click)="toggleRow(i)">{{records?.customerName}}</td>
                                    <td (click)="toggleRow(i)">{{records?.email}}</td>
                                    <td (click)="toggleRow(i)">{{records?.mobile}}</td>
                                    <td (click)="toggleRow(i)">{{records?.date | date:'short':'IST' }}</td>
                                    <td (click)="toggleRow(i)">{{records?.description}}</td>
                                    <td (click)="toggleRow(i)">{{records?.propType}}</td>
                                    <td>
                                        <!-- Add any action buttons here -->
                                        <button class="btn btn-sm btn-primary" (click)="view(records)">View</button>
                                    </td>     
                                
                                </tr>
                                <ng-container *ngIf="expandedIndex === i">
                                    <tr>
                                        <td colspan="12" class="bg-light">
                                            <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                                <a (click)="toggleRow(i)" style="cursor: pointer;"><i
                                                        class="fa-solid fa-chevron-up text-right d-block mb-2"></i> </a>
                                                <p *ngFor="let history of childData" class="mb-1">
                                                    <b>{{history.createdAt | date:'short':'IST'}}:</b>
                                                    {{history.description}}- <b>Followup Date</b>: <b class="text-primary" style="color: green;">{{history.date | date:'short':'IST'}} </b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                                    </ng-container>
                           
                        </tbody>
                    </table>
                </div>
            </div>
        </main>
    
    </div>
</div>